export default "__VITE_ASSET__MkqC$7Zg__"